import {Component, Input} from '@angular/core';
import {Service} from '../../../entities/photographer/service.entity';
import {CurrencyPipe, JsonPipe} from '@angular/common';
import {TranslocoPipe} from '@jsverse/transloco';
import {AppImageComponent} from '../../../../core/components/image/image';

@Component({
  selector: 'app-photographer-service',
  imports: [
    CurrencyPipe,
    TranslocoPipe,
    AppImageComponent
  ],
  templateUrl: './photographer-service.html',
  styleUrls: ['./photographer-service.scss']
})
export class PhotographerService {
  @Input() service: Service|null = null;
  @Input() imageSize: number = 156;

  public getCoverImage(): string|null {
    const mainImage = (this.service as any)?.image ?? null;
    if (mainImage) {
      return mainImage;
    }

    const photos = (this.service as any)?.photos ?? [];
    if (Array.isArray(photos) && photos.length > 0) {
      const firstPhotoWithUrl = photos.find((photo: any) => !!photo?.url);
      return firstPhotoWithUrl?.url ?? null;
    }

    return null;
  }

  public hasDiscount(): boolean {
    const discountActive = (this.service as any)?.discountActive ?? (this.service as any)?.discount_active;
    const discount = this.getDiscountValue();

    return !!discountActive && discount > 0;
  }

  public getDiscountValue(): number {
    return (this.service as any)?.discount ?? (this.service as any)?.discount ?? 0;
  }

  public hasPriceRange(): boolean {
    return !!((this.service as any)?.priceRangeActive ?? (this.service as any)?.price_range_active);
  }

  public getMinPublicPrice(): number|null {
    return (this.service as any)?.priceRangeMinPublic ?? (this.service as any)?.price_range_min_public ?? null;
  }

  public getPublicPrice(): number|null {
    return (this.service as any)?.publicPrice ?? null;
  }

  public getDiscountedPrice(amount: number|null): number|null {
    if (amount === null) {
      return null;
    }

    const discount = this.getDiscountValue();
    return amount * (1 - discount / 100);
  }
}
